import React, { FC } from 'react';
import CloseDialogButton from '../CloseDialogButton';
import OpenDialogButton from '../OpenDialogButton';

type ChatPanelProps = {
  id: string;
  finalizeMessage: boolean;
};

const ChatPanel: FC<ChatPanelProps> = ({ finalizeMessage, id }) => {
  if (!finalizeMessage) {
    return <CloseDialogButton id={id} />;
  }
  return <OpenDialogButton id={id} />;
};

export default ChatPanel;
